module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00001-1c629af9b4d5d92c827d3c69632a187c.jpg";